import {QuestionBase} from "./question-base";

export class PersonContact extends QuestionBase<string> {
  override controlType = 'personcontact';
}
